import React from 'react';

const doc = (props) => {
  const findADoc = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'Click',
      'eventAction': 'Load Website',
      'eventLabel': 'Find a Doc',
      'eventValue': undefined
    });
  };
  const heading = props.wny ? <h2>Your doctor is most likely in!</h2> : <h2>We&rsquo;re 99% sure your doctor&nbsp;is&nbsp;in!</h2>;

  return (
    <section id='doc' className='divide'>
      <div className='wrap'>
        {heading}
        <h4><a
          href={props.search}
          target='_blank'
          rel='noopener noreferrer'
          onClick={findADoc}
        >Search now</a> to see that your preferred providers and hospitals are in our&nbsp;network.</h4>
      </div>
    </section>
  );
};

export default doc;
